import React, { Component } from 'react';
import { withRouter, RouteComponentProps, NavLink } from 'react-router-dom';
import b from 'b_';

import { isExternalUrl } from 'client/helpers/isExternalUrl';
import { HeadMenuItem } from '@interfaces/head-menu';
import Button from '@components/button';
import Icon from '@components/icon';

import './app-menu.css';

const class_ = b.with('app-menu');

export interface StateProps {
    links?: HeadMenuItem[];
    pathname?: string;
}

interface AppMenuProps extends RouteComponentProps<{}> {
    withBackground?: boolean;
}

interface State {
    inputActive: boolean;
}

class AppMenu extends Component<AppMenuProps & StateProps, State> {
    public readonly state = {
        inputActive: false
    };

    public onSearchClick = () => {
        if (this.isSearchPage()) {
            return;
        }
        this.setState({ inputActive: true });
    };

    public onSearchKey = (e: any) => {
        const { value } = e.target;

        if (e.key === 'Enter' && value.trim()) {
            this.props.history.push(`/search?text=${encodeURIComponent(value)}`);
            this.setState({ inputActive: false });
        }
    };

    public render() {
        const { withBackground = true, links = [] } = this.props;
        const { inputActive } = this.state;
        const className = withBackground ? class_() : class_({ background: 'hidden' });
        const searchTheme = this.isSearchPage() ? 'normal' : 'clear';

        return (
            <div className={className}>
                {links.map(({ link, title }) => isExternalUrl(link) ? (
                        <a
                            key={title}
                            href={link}
                            className={class_('item')}
                        >
                            {title}
                        </a>
                    ) : (
                        <NavLink
                            exact={link === '/'}
                            key={title}
                            to={link}
                            className={class_('item')}
                            activeClassName={class_('item', { active: true })}
                        >
                            {title}
                        </NavLink>
                    )
                )}
                {inputActive ? (
                    <div className={class_('search-input-container')}>
                        <input
                            className={class_('search-input')}
                            type="text"
                            autoFocus
                            onKeyDown={this.onSearchKey}
                        />
                    </div>
                ) : (
                    <Button cls={class_('search-btn')} theme={searchTheme} onClick={this.onSearchClick}>
                        <Icon size="l" type="search" />
                    </Button>
                )}
            </div>
        );
    }

    private isSearchPage = () => {
        const { pathname = '' } = this.props;

        return /^\/search.*$/.test(pathname);
    };
}

export default withRouter(AppMenu);
